import { WALLET_CAPTCHA_ANALYTICS } from '../actionTypes/WalletBarcodeActionTypes';

export const walletCaptchaAnalytics = (eventName, data) => ({
    type: WALLET_CAPTCHA_ANALYTICS,
    eventName,
    data,
});

export default walletCaptchaAnalytics;
